import type { BetterDocSpecialty } from "@/modules/patients/detail/better-doc/lib/better-doc-sub-specialties"

const DE_BETTER_DOC_SUB_SPECIALTIES: Partial<Record<BetterDocSpecialty, readonly string[]>> = {
  GENERAL_INTERNAL_MEDICINE: ["geriatrics"],
  SURGERY: ["general_surgery_traumatology", "visceral_surgery", "surgical_senology"],
  DERMATOLOGY_AND_VENEREOLOGY: ["dermatopathology"],
  GASTROENTEROLOGY: ["hepatologie"],
  GYNECOLOGY_AND_OBSTETRICS: [
    "operative_gynecology_and_obstetrics",
    "gynecologic_oncology",
    "fetomaternal_medicine",
    "reproductive_medicine_and_gynecological_endo",
    "urogynecology",
    "gynecological_senology",
  ],
  INFECTIOLOGY: ["infection_prevention_and_control"],
  PEDIATRICS_AND_ADOLESCENT_MEDICINE: [
    "pediatric_endocrinology_diabetology",
    "pediatric_gastroenterology_and_hepatology",
    "pediatric_cardiology",
    "neonatology",
    "pediatric_nephrology",
    "neuropaediatrics",
    "pediatric_oncology_hematology",
    "pediatric_pneumology",
    "pediatric_rheumatology",
    "developmental_pediatrics",
    "pediatric_emergency_medicine",
  ],
  PEDIATRIC_SURGERY: ["pediatric_emergency_med"],
  OPHTHALMOLOGY: ["ophthalmology"],
  OTO_RHINO_LARYNGOLOGY: ["ear_nose_throat_phoniatrics"],
  PATHOLOGY: ["cytopathology_pathology", "mol_pathology"],
  RADIOLOGY: ["pediatric_radiology", "diagnostic_neuroradiology", "invasive_neuroradiology"],
  UROLOGY: ["operative_urology", "neurourology", "urology_for_women"],
}

export const getDeBetterDocSubSpecialties = (specialtyName: BetterDocSpecialty | undefined): readonly string[] =>
  specialtyName === undefined ? [] : (DE_BETTER_DOC_SUB_SPECIALTIES[specialtyName] ?? [])
